import { useTranslation } from "react-i18next";
import SearchIcon from "../../../../icons/searchIcon";
import DataTable from "../../../../components/table/dataTable";
import Paginate from "../../../../components/pagination/paginate";
import DownloadIcon from "../../../../icons/downloadIcon";

const RequestsReplies = () => {
  const { t } = useTranslation();

  const tableHead = [
    { header: t("orderNumber"), accessorKey: "orderNumber" },
    { header: t("reply"), accessorKey: "reply" },
    { header: t("replyStatus"), accessorKey: "replyStatus" },
    { header: t("sentDate"), accessorKey: "sentDate" },
    { header: t("download"), accessorKey: "download" },
  ];
  const shipmentData = [
    {
      orderNumber: "ORDER1001",
      reply: "السعر 150$",
      sentDate: "27/07/2024",
      replyStatus: "تم العرض",
      download: "تفاصيل",
    },
    {
      orderNumber: "ORDER1002",
      reply: "السعر 150$",
      sentDate: "28/07/2024",
      replyStatus: "تم العرض",
      download: "تتبع",
    },
    {
      orderNumber: "ORDER1003",
      reply: "السعر 150$",
      sentDate: "29/07/2024",
      replyStatus: "تم العرض",
      download: "إلغاء",
    },
    {
      orderNumber: "ORDER1004",
      reply: "السعر 150$",
      sentDate: "30/07/2024",
      replyStatus: "تم العرض",
      download: "تعديل",
    },
    {
      orderNumber: "ORDER1004",
      reply: "السعر 150$",
      sentDate: "30/07/2024",
      replyStatus: "تم العرض",
      download: "تعديل",
    },
    {
      orderNumber: "ORDER1004",
      reply: "السعر 150$",
      sentDate: "30/07/2024",
      replyStatus: "تم العرض",
      download: "تعديل",
    },
    {
      orderNumber: "ORDER1004",
      reply: "السعر 150$",
      sentDate: "30/07/2024",
      replyStatus: "تم العرض",
      download: "تعديل",
    },
    {
      orderNumber: "ORDER1004",
      reply: "السعر 150$",
      sentDate: "30/07/2024",
      replyStatus: "تم العرض",
      download: "تعديل",
    },
    {
      orderNumber: "ORDER1004",
      reply: "السعر 150$",
      sentDate: "30/07/2024",
      replyStatus: "تم العرض",
      download: "تعديل",
    },
    {
      orderNumber: "ORDER1004",
      reply: "السعر 150$",
      sentDate: "30/07/2024",
      replyStatus: "تم العرض",
      download: "تعديل",
    },
    {
      orderNumber: "ORDER1004",
      reply: "السعر 150$",
      sentDate: "30/07/2024",
      replyStatus: "تم العرض",
      download: "تعديل",
    },
  ];
  const tableData = shipmentData.map((d, i) => {
    const replyStatus = (
      <span className="py-2 w-[100px] block mx-auto rounded-lg bg-[#E6F4EF]">
        {d.replyStatus}
      </span>
    );
    const download = (
      <span className="flex items-center justify-center gap-2 ">
        {t("download")} <DownloadIcon />
      </span>
    );
    return {
      orderNumber: d.orderNumber,
      reply: d.reply,
      sentDate: d.sentDate,
      replyStatus,
      download,
    };
  });
  const data = { last_page: 20 };
  const handlePagination = () => {};
  return (
    <div className="min-w-full p-5 capitalize bg-white rounded-2xl">
      <section className="flex border-b border-b-[#888888] pb-2 flex-wrap items-center justify-between">
        <div className="font-medium">{t("assignedShipments")}</div>
        <div className="flex border   border-[#F9F9F9] focus-within:border-black items-center gap-4 bg-[#F9F9F9] rounded-full px-4">
          <SearchIcon />
          <input
            type="text"
            className="flex-1 py-2 bg-transparent  min-w-[400px] focus:border-none focus-visible:outline-none"
            placeholder={t("search")}
          />
        </div>
      </section>
      <div className="min-w-full my-5 overflow-x-auto">
        <DataTable TableHead={tableHead} TableData={tableData} />
      </div>
      <Paginate handlePagination={handlePagination} data={data} />
    </div>
  );
};

export default RequestsReplies;
